import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";

export interface AnalysisFieldInitialValue {
  status?: string;
  observacao?: string;
}

export interface AnalysisFieldProps {
  idCampo: string;
  initialValue?: AnalysisFieldInitialValue;
  onChange?: (idCampo: string, valores: AnalysisFieldInitialValue) => void;
  erro?: boolean;
  disabled?: boolean;
}

const AnalysisField = ({
  idCampo,
  initialValue = {},
  onChange,
  erro = false,
  disabled = false,
}: AnalysisFieldProps) => {
  const [status, setStatus] = useState("");
  const [observacao, setObservacao] = useState("");

  useEffect(() => {
    setStatus(initialValue.status ?? "");
    setObservacao(initialValue.observacao ?? "");
  }, [initialValue]);

  const handleStatusChange = (novoStatus: string) => {
    if (disabled) return;
    setStatus(novoStatus);
    if (onChange) {
      onChange(idCampo, { status: novoStatus, observacao });
    }
  };

  const handleObservacaoChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (disabled) return;
    const novaObs = e.target.value;
    setObservacao(novaObs);
    if (onChange) {
      onChange(idCampo, { status, observacao: novaObs });
    }
  };

  return (
    <div className="mt-4 p-4 bg-light-subtle rounded shadow-sm border">
      <h5 className="fw-bold border-bottom pb-2 mb-3">ANÁLISE</h5>

      <Form.Group className="mt-3">
        <Form.Label className="fw-semibold">Situação</Form.Label>
        <div
          className={`d-flex gap-4 ${erro ? "border border-danger p-2 rounded" : ""
            }`}
        >
          <Form.Check
            type="radio"
            id={`status-${idCampo}-conforme`}
            label="CONFORME"
            name={`status-${idCampo}`}
            value="CONFORME"
            checked={status === "CONFORME"}
            onChange={() => handleStatusChange("CONFORME")}
            disabled={disabled}
          />
          <Form.Check
            type="radio"
            id={`status-${idCampo}-nao-conforme`}
            label="NÃO CONFORME"
            name={`status-${idCampo}`}
            value="NAO_CONFORME"
            checked={status === "NAO_CONFORME"}
            onChange={() => handleStatusChange("NAO_CONFORME")}
            disabled={disabled}
          />
        </div>
      </Form.Group>

      <Form.Group className="mt-3">
        <Form.Label className="fw-semibold">Observação</Form.Label>
        <Form.Control
          as="textarea"
          rows={3}
          value={observacao}
          maxLength={10000}
          onChange={handleObservacaoChange}
          disabled={disabled}
          className={erro ? "is-invalid" : ""}
        />
        <div className="text-muted text-end small">
          {disabled
            ? "Observação travada: análise concluída (somente leitura)."
            : "Máximo 10.000 caracteres"}
        </div>
      </Form.Group>
    </div>
  );
};

export default AnalysisField;
